import * as React from "react";
import {cx} from "emotion";

import "./delivery-methods.scss";

export const DeliveryMethods = ({templateOptions, state, item, extra}) => (
    <div className="delivery-methods-4f5">
        <div className="header">
            <div className="title">
                <div className="label" xd-qa-type="label" xd-qa-name="Delivery Method">
                    Delivery Method
                </div>
                {extra && (
                    <div className="extra">
                        {extra()}
                    </div>
                )}
            </div>
            <div className="sub-title" xd-qa-type="label" xd-qa-name="Ship Date Notification">
                Ship date may vary depending on the service level
            </div>
        </div>

        <div className="card">
            <div className="methods">
                {methods
                    .filter((m) => templateOptions.distributions.includes(m.name))
                    .filter((m) => m.name !== "pickup" || item?.programType !== "Scheduled Campaigns")
                    .map((m) => {
                        const selected = state.value === m.name;
                        return (
                            <div
                                className={cx("method", {selected})}
                                key={m.name}
                                onClick={() => state.onChange(m.name)}
                            >
                                <i className={"fa fa-" + m.icon} xd-qa-type="icon" xd-qa-name={m.label}/>
                                <div className="label" xd-qa-type="button" xd-qa-name={m.label}>
                                    {m.label}
                                </div>

                                {selected && (
                                    <div className="check">
                                        <i className="fa fa-check-circle" xd-qa-type="icon" xd-qa-name="Delivery Method Check"/>
                                    </div>
                                )}
                            </div>
                        );
                    })
                }
            </div>
        </div>
    </div>
);

const methods = [
    {
        name: "mailing",
        label: "Mail",
        icon: "envelope",
    },
    {
        name: "shipping",
        label: "Ship",
        icon: "truck",
    },
    {
        name: "download",
        label: "Download",
        icon: "download",
    },
    {
        name: "pickup",
        label: "Pickup",
        icon: "map-marker",
    },
];